import { useMemo } from 'react';
import { type LinkProps, useLocation } from 'react-router';

import { getPathWithRedirect } from '../utils/path-with-redirect';

/**
 * Builds a link target with a `redirectTo` parameter pointing back to the
 * current path, so the destination can return here afterwards. A memoized
 * wrapper around {@link getPathWithRedirect}. For imperative navigation,
 * use {@link useNavigateWithRedirect}.
 *
 * @param to The link target to append the redirect parameter to.
 * @returns The target with the redirect parameter added.
 */
export const usePathWithRedirect = (to: LinkProps['to']) => {
  const location = useLocation();

  const path = useMemo(() => {
    return getPathWithRedirect(to, location.pathname);
  }, [location.pathname, to]);
  return path;
};
